import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import GarageOutlinedIcon from '@mui/icons-material/GarageOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import SportsMotorsportsOutlinedIcon from '@mui/icons-material/SportsMotorsportsOutlined';

export const PAGE_ICONS = {
  team: <Groups2OutlinedIcon />,
  garage: <GarageOutlinedIcon />,
  circuits: <MapOutlinedIcon />,
  sessions: <FlagOutlinedIcon />,
  telemetry: <SpeedOutlinedIcon />,
  settings: <SettingsOutlinedIcon />,
  plans: <PaymentsOutlinedIcon />,
  maintenance: <BuildOutlinedIcon />,
  coaching: <SportsMotorsportsOutlinedIcon />,
} as const;
